import { Group } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Group>;
export const DropdownGroup = (props: Props) => {
    return <Group data-testid="dropdown-group" {...props} />;
};
